<template>
    <div id="app" class="pb-4">
        <router-view
            :first_name="first_name"
            :last_name="last_name"
            :email="email"
            @updateField="updateField($event)"
        />
    </div>
</template>

<script>
export default {
    data(){
        return {
            first_name: '',
            last_name: '',
            email: '',
        }
    },
    methods: {
        updateField({field, value}){
            this[field] = value;
        }
    },
}
</script>

<style scoped>

</style>